"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapComponent = void 0;
var querystring_1 = __importDefault(require("querystring"));
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var environment_1 = __importDefault(require("../../environments/environment"));
var util_1 = require("../util");
var MapComponent = /** @class */ (function () {
    function MapComponent(element, library$) {
        var _this = this;
        this.element = element;
        this.markers = [];
        this.kmap$ = library$.pipe(operators_1.map(function () { return _this.createKakaoMap(); }), operators_1.tap(function (kmap) { _this.kmap = kmap; }), operators_1.shareReplay(1));
    }
    MapComponent.loadLibrary = function () {
        var query = querystring_1.default.stringify({
            appkey: environment_1.default.kakaomap_api_options.app_key,
            libraries: 'services',
            autoload: false,
        });
        return util_1.loader.script('//dapi.kakao.com/v2/maps/sdk.js?' + query).pipe(operators_1.switchMap(function (url) {
            return new rxjs_1.Observable(function (observer) {
                kakao.maps.load(function () {
                    observer.next();
                    observer.complete();
                });
            });
        }));
    };
    MapComponent.prototype.init = function () {
        this.kmap$.subscribe();
        return this;
    };
    MapComponent.prototype.beInitialized = function () {
        return this.kmap$.toPromise();
    };
    MapComponent.prototype.createKakaoMap = function () {
        var _this = this;
        var element = this.element;
        var options = {
            center: new kakao.maps.LatLng(37.486764228403764, 126.89303611174554),
            level: 4,
        };
        var kmap = new kakao.maps.Map(element, options); // 지도 생성 및 객체 리턴
        kakao.maps.event.addListener(kmap, 'click', function (ev) { return _this.onClickOnMap(ev); });
        return kmap;
    };
    MapComponent.prototype.onClickOnMap = function (ev) {
        this.element.dispatchEvent(new CustomEvent('map-click', {
            detail: {
                latLng: {
                    lat: ev.latLng.getLat(),
                    lng: ev.latLng.getLng(),
                },
                point: {
                    x: ev.point.x,
                    y: ev.point.y,
                },
            }
        }));
    };
    MapComponent.prototype.clearMarkers = function () {
        for (var _i = 0, _a = this.markers; _i < _a.length; _i++) {
            var marker = _a[_i];
            marker.setMap(null);
        }
        this.markers = [];
    };
    MapComponent.prototype.addMarkerAt = function (position, image) {
        var marker = new kakao.maps.Marker({
            position: new kakao.maps.LatLng(position.lat, position.lng),
            image: image,
            map: this.kmap,
        });
        this.markers.push(marker);
        return marker;
    };
    MapComponent.prototype.createMarkerImage = function (src, size, options) {
        return new kakao.maps.MarkerImage(src, size, options);
    };
    MapComponent.prototype.getPositionOf = function (marker) {
        var latLng = marker.getPosition();
        return {
            lat: latLng.getLat(),
            lng: latLng.getLng(),
        };
    };
    MapComponent.prototype.createInfoWindow = function (position, content, options) {
        var iw = new kakao.maps.InfoWindow({
            position: new kakao.maps.LatLng(position.lat, position.lng),
            content: content,
            removable: options === null || options === void 0 ? void 0 : options.removable
        });
        iw.open(this.kmap, options === null || options === void 0 ? void 0 : options.marker);
        return iw;
    };
    MapComponent.prototype.createSingleInfoWindow = function (position, content, options) {
        if (this.siw)
            this.siw.close();
        this.siw = this.createInfoWindow(position, content, options);
    };
    MapComponent.prototype.closeSingleInfoWindow = function () {
        if (this.siw)
            this.siw.close();
    };
    MapComponent.prototype.setCenter = function (position) {
        this.kmap.setCenter(new kakao.maps.LatLng(position.lat, position.lng));
    };
    MapComponent.prototype.getCenter = function () {
        var position = this.kmap.getCenter();
        return { lat: position.getLat(), lng: position.getLng() };
    };
    /**
     * @param level SKYVIEW, HYBRID 일 경우 0 ~ 14, ROADMAP 일 경우 1 ~ 14
     */
    MapComponent.prototype.setLevel = function (level) {
        this.kmap.setLevel(level);
    };
    MapComponent.prototype.getLevel = function () {
        return this.kmap.getLevel();
    };
    MapComponent.prototype.relayout = function () {
        this.kmap.relayout();
    };
    MapComponent.prototype.searchAddress = function (addr) {
        return new rxjs_1.Observable(function (observer) {
            var geocoder = new kakao.maps.services.Geocoder();
            geocoder.addressSearch(addr, function (result, status) {
                if (status === kakao.maps.services.Status.OK) {
                    observer.next({ lat: result[0].y, lng: result[0].x });
                    observer.complete();
                }
                else {
                    console.warn('searching address failed:', status, result);
                    observer.error();
                }
            });
        });
    };
    return MapComponent;
}());
exports.MapComponent = MapComponent;
